import SessionLanguage from "@olivahealth/business/src/Core/domain/value-objects/SessionLanguage";
import { automatedSummarySupportedLanguages } from "@olivahealth/business/src/Core/utils/Language";

export const sessionSupportsAutomatedSummary = (
  sessionLanguage?: SessionLanguage | string,
) => {
  if (!sessionLanguage) {
    return false;
  }

  return Boolean(
    automatedSummarySupportedLanguages.find(
      (lang) => lang.code === sessionLanguage,
    ),
  );
};
